import React, { ReactNode } from 'react';
import { ToggleWrapper } from './ToggleWrapper';
import { ToggledFeature } from './featureToggleService';

export function ClientPortalBrandingToggleWrapper(
  props: {
    children: ReactNode;
  }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.CLIENT_PORTAL_BRANDING}>
      {props.children}
    </ToggleWrapper>
  );
}
